import React from "react";
import App from "./App";
import Gallery from "./Gallery";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function Root() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
    </Router>
  );
}

export default Root;
